import React, { useEffect } from 'react';
import cn from 'classnames';
import type { AdItem } from '@sbt-web/network/types';
import { Card } from './card';
import { useMediaQuery } from '@sbt-web/hooks';
import { Carousel } from '@sbt-web/carousel';
import '@sbt-web/carousel/style';
import styles from './index.module.scss';
import cardStyles from './card/index.module.scss';
import { DeviceWidth } from '@sbt-web/ui';
import { trackView, trackImpression } from './tracking';
import { connect } from 'react-redux';
import type { RootState } from '@reducers/index';
import { getRankFor } from '@shared/helpers/Rank';
import { getRankedUrnForGeoboost } from '@shared/helpers/Rank/store';
import { useTrackImpression } from '@tools/tracking/useTrackImpression';

type StateProps = {
  rank?: number;
  searchId: string;
};
type OwnProps = {
  items: AdItem[];
};

type Props = OwnProps & StateProps;

const Geoboost = ({ items, rank, searchId }: Props) => {
  const showCarouselNavigation = useMediaQuery(
    `(min-width: ${DeviceWidth.desktop.min})`
  );
  const countCssClass = styles[`count--${items.length}`];
  const componentRef = React.useRef(null);
  const setComponentRef = useTrackImpression({
    enabled: true,
    track: () => {
      trackImpression(items, rank ?? -1);
    },
  });

  useEffect(() => {
    trackView(items, rank ?? -1);
  }, [items, rank]);

  useEffect(() => {
    if (componentRef?.current) {
      setComponentRef(componentRef.current);
    }
  }, [setComponentRef, componentRef]);

  const cards = items.map((ad, index) => (
    <li key={ad.urn}>
      <Card
        className={cn(
          styles['card'],
          cardStyles[
            `card-${items.length > 1 ? 'mini' : 'landscape'}-on-msite`
          ],
          cardStyles[
            `card-${items.length > 4 ? 'mini' : 'landscape'}-on-desktop`
          ]
        )}
        ad={ad}
        rank={index}
        searchId={searchId}
      />
    </li>
  ));

  return (
    <section
      className={`${styles['container']} ${countCssClass}`}
      ref={componentRef}
    >
      <h6 className={`${styles['title']} headline-6`}>Scelti per te</h6>
      {items.length < 3 ? (
        <ul className={`${styles['raw-items']}`}>{cards}</ul>
      ) : (
        <Carousel
          cssClass={`${styles['carousel']} slider-nav-round`}
          labelArrows={{ right: 'Avanti', left: 'Indietro' }}
          showButtons={showCarouselNavigation}
          currentIndex={0}
          listItems={cards}
        />
      )}
    </section>
  );
};

function mapStateToProps(state: RootState, ownProps: OwnProps): Props {
  const { items } = ownProps;
  return {
    ...ownProps,
    searchId: state.search?.id ?? '',
    rank: getRankFor(
      getRankedUrnForGeoboost(items),
      'GeoboostItem',
      state.search,
      state.items
    ),
  };
}

export { Geoboost };
export default connect<Props, void, OwnProps, RootState>(mapStateToProps)(
  Geoboost
);
